import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Row, Col, Button} from 'react-bootstrap';
import PointsTransactionsList from './points-transactions-list';
import PointsTransactionsSearch from './points-transactions-search';
import {getPointsTransactions} from '../../../../actions/points';
import PageTitle from '../../../common/page-title/index';
import ArrowButton from '../../../common/button-arrow';
import {Link} from 'react-router-dom';

import './styles.css'

class PointsTransactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerNumber: '',
      dateFrom: '',
      dateTo: '',
      pointsPot: [],
      pageNumber: 1
    };
  }

  componentWillMount() {
    this.props.dispatch(getPointsTransactions());
  }

  handleInputChange = (e) => {
    this.setState({customerNumber: e.target.value});
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateFrom: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateFrom: ''});
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateTo: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateTo: ''});
    }
  };

  handlePointsPotChange = (e) => {
    this.setState({pointsPot: e});
  };

  handleSearch = () => {
    const {customerNumber, dateFrom, dateTo, pointsPot} = this.state;
    this.props.dispatch(getPointsTransactions(customerNumber, dateFrom, dateTo, pointsPot)).then(() => {
      this.setState({
          pageNumber: 1
      });
    });
  };

  handleClear = () => {
    this.setState({
      customerNumber: '',
      dateFrom: '',
      dateTo: '',
      pointsPot: [],
      pageNumber: 1
    }, this.handleSearch);
  };

  handlePageChange = (page, size) => {
    this.setState({pageNumber:  page}, this.afterPageChange);
  };

  afterPageChange = () => {
    const {customerNumber, dateFrom, dateTo, pointsPot, pageNumber} = this.state;
    this.props.dispatch(getPointsTransactions(customerNumber, dateFrom, dateTo, pointsPot, pageNumber))
  };

  render() {
    let table = <div/>;
    let search = <div>Loading..</div>;
    if (this.props.fetched) {
      table = <PointsTransactionsList
        points_transactions={this.props.points_transactions}
        fetching={this.props.fetching}
        fetched={this.props.fetched}
        paging={this.props.paging}
        onPageChange={this.handlePageChange}
        currentPage={this.state.pageNumber}/>;

      search = <PointsTransactionsSearch
        pointsPotList={this.props.pointsPotList}
        searchValue={this.state.orderNumber}
        pointsPotValue={this.state.pointsPot}
        dateFromValue={this.state.dateFrom}
        dateToValue={this.state.dateTo}
        onInputChange={this.handleInputChange}
        onDateFromChange={this.handleDateFromChange}
        onDateToChange={this.handleDateToChange}
        onPointsPotChange={this.handlePointsPotChange}
        onSearch={this.handleSearch}
        onClear={this.handleClear}/>
    }
    return (
      <Grid bsClass="container" fluid className="orders">
        <PageTitle>Points Transactions</PageTitle>
        <Col md={12}>
          <Row>
            <Link to="/admin/manual-points-transactions">
              <ArrowButton color="red"
                           arrow={false}
                           submit={false}
                           className="float-right"
                           permissions={{
                             action:       "create",
                             subjectClass: "PointTransaction",
                           }}
              >Add Points Transactions</ArrowButton>
            </Link>
          </Row>
        </Col>
        <Row>
          <Col md={12}>
          {search}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {table}

          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    fetching:            state.points.fetching,
    fetched:             state.points.fetched,
    pointsPotList:       state.points.meta['point-pots'],
    points_transactions: state.points.transactions.list,
    paging:              state.points.transactions.paging,
    links:               state.points.transactions.links
  };
};

export default connect(mapStateToProps)(PointsTransactions);


// WEBPACK FOOTER //
// ./src/components/admin/points/points-transactions/index.jsx